import { render, staticRenderFns } from "./IconButtonView.vue?vue&type=template&id=2a078ef0&"
import script from "./IconButtonView.vue?vue&type=script&lang=js&"
export * from "./IconButtonView.vue?vue&type=script&lang=js&"
import style0 from "./IconButtonView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports